export default {
	i18n: require('./i18n').default,
	props: ['orderName', 'orderId']
};
